import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import MypageReturn from '../molecules/MypageReturn';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';
import { Row, Col } from 'react-bootstrap';

interface Props {
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: VoidFunction;
  requestModule: () => void | boolean;
  requestModuleAutodisplay: () => void | boolean;
}

// KWANKGM02010_借入相談入力フッタボタン
const FooterBorrowingConsultationInput: React.FC<Props> = ({
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  requestModule,
  requestModuleAutodisplay,
}) => {
  const history = useHistory();

  const handleClickNext = async () => {
    const autodispay_result = await requestModuleAutodisplay();
    const valid_result = await requestModule();

    // バリデーションエラーがあるか判定
    if (valid_result) {
      // エラーが無ければ確認画面へ遷移
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/confirm`);
    }
  };

  return (
    <>
      <Row className="mt-5">
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <p>
            連帯債務者等がいる場合、連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
            <br />
            連帯債務者等の確認状況はマイページから確認可能です。
          </p>
        </Col>
      </Row>
      <RowCenterButton>
        <DefaultButton label="借入相談をする" strong={false} handleClick={handleClickNext} />
      </RowCenterButton>
      <MypageReturn is_staff={is_staff} />
    </>
  );
};

export default memo(FooterBorrowingConsultationInput);
